export const TYPES_DOMMAGES = [
  { value: 'fissures', label: 'Fissures structurelles' },
  { value: 'infiltration', label: 'Infiltrations / Étanchéité' },
  { value: 'solidite', label: 'Atteinte à la solidité (Gros œuvre)' },
  { value: 'equipement', label: 'Équipement indissociable' },
  { value: 'fondations', label: 'Problèmes de fondations' },
  { value: 'toiture', label: 'Désordres de toiture' },
  { value: 'autre', label: 'Autre (préciser dans la description)' }
];

export const STATUS_COLORS = {
  DECLARE: 'bg-gray-500',
  EN_INSTRUCTION: 'bg-blue-500',
  EXPERTISE_PLANIFIEE: 'bg-yellow-500',
  EXPERTISE_REALISEE: 'bg-teal-500',
  COMITE_SOLIDAIRE: 'bg-orange-500',
  ACCEPTE: 'bg-green-500',
  REFUSE: 'bg-red-500',
  EN_REPARATION: 'bg-indigo-500',
  CLOTURE: 'bg-gray-600'
};
